/**
 * Constants for the questions used for section headings on the support page.
 */
const Questions = {
  Initial: 1,
  PleaseSelect: 2,
  IssueKind: 3,
  PreferredResolution: 4,
  IWouldLike: 5,
  WasThisHelpful1: 6,
  WasThisHelpful2: 7,
};

export default Questions;
